<div class="flex size-full flex-col overflow-y-auto bg-surface-A p-12">
    <button
        interacta-button
        type="button"
        [icon]="'plus'"
        [label]="'AI.SIDE_PANEL.NEW_CHAT' | translate"
        [size]="'small'"
        [style]="'tonal'"
        (click)="newChat.emit()"
    ></button>

    @if (history().isFetching || history().list.length) {
        <section class="mt-16 flex flex-col gap-y-8">
            @if (history().isFetching) {
                <div
                    class="my-8 h-16 w-80 animate-pulse rounded bg-surface-300"
                ></div>
                @for (_ of 3 | array; track $index) {
                    <div
                        aria-hidden="true"
                        class="h-48 w-full animate-pulse rounded bg-surface-300"
                    ></div>
                }
            } @else {
                <div class="flex items-center justify-between p-4">
                    <h3 class="typo-xs-bold-uppercase text-text-mid-contrast">
                        {{ 'AI.SIDE_PANEL.SETTINGS.HISTORY' | translate }}
                    </h3>
                    <button
                        interacta-button
                        type="button"
                        [label]="
                            'AI.SIDE_PANEL.SETTINGS.SHOW_ALL_HISTORY'
                                | translate
                        "
                        [size]="'small'"
                        [style]="'text'"
                        (click)="showAllHistory.emit()"
                    ></button>
                </div>

                @for (
                    item of history().list.slice(0, 3);
                    track item.sessionId
                ) {
                    <interacta-ai-convo-history-list-item
                        [item]="item"
                        (deleteClick)="historyItemDelete.emit($event)"
                        (itemClick)="historyItemClick.emit($event)"
                        (renameClick)="historyItemRename.emit($event)"
                    />
                }
            }
        </section>
    }

    @if (agentsFetching() || agents().length) {
        <section class="mt-16 flex flex-col gap-y-8">
            @if (agentsFetching()) {
                <div
                    class="my-8 h-16 w-80 animate-pulse rounded bg-surface-300"
                ></div>
                @for (_ of 3 | array; track $index) {
                    <div
                        aria-hidden="true"
                        class="h-46 w-full animate-pulse rounded bg-surface-300"
                    ></div>
                }
            } @else {
                <div class="flex items-center justify-between p-4">
                    <h3 class="typo-xs-bold-uppercase text-text-mid-contrast">
                        {{ 'AI.SIDE_PANEL.SETTINGS.AGENTS' | translate }}
                    </h3>
                    <button
                        interacta-button
                        type="button"
                        [label]="'SHARED.SHOW_ALL' | translate"
                        [size]="'small'"
                        [style]="'text'"
                        (click)="showAllAgents.emit()"
                    ></button>
                </div>

                @for (agent of agents().slice(0, 3); track agent.id) {
                    <interacta-ai-convo-agent-list-item
                        [agent]="agent"
                        [showDescription]="false"
                        (agentClick)="agentSelected.emit($event)"
                    />
                }
            }
        </section>
    }

    <p class="mt-auto pt-16 typo-sm-bold">
        {{ 'AI.DISCOVERY.PANEL_CTA_QUESTION' | translate }}
        <button
            class="text-text-link underline"
            type="button"
            (click)="openDiscoveryDialog()"
        >
            {{ 'AI.DISCOVERY.PANEL_CTA_LINK' | translate }}
        </button>
    </p>
</div>
